import { z } from 'zod';
import { PRODUCT_TREE_CONSTRAINTS } from './constraints.js';
// Same flat shape as create-form.ts (name/description/brandId/parentId), not a narrower
// name/description/parentId-only shape -- brandId rides along in RHF state purely for display
// (a category's brand is immutable post-creation, see update-input.ts's comment) so
// product-tree-fields.tsx can stay one component instead of two near-identical field-set variants.
// update-mapper.ts below never reads brandId out of these values; UpdateProductTreeInputValue has
// no brandId key at all.
export const productTreeEditFormSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, 'Category name cannot be empty.')
        .max(PRODUCT_TREE_CONSTRAINTS.name.maxLength, `${PRODUCT_TREE_CONSTRAINTS.name.label} must be ${PRODUCT_TREE_CONSTRAINTS.name.maxLength} characters or fewer`),
    description: z
        .string()
        .trim()
        .max(PRODUCT_TREE_CONSTRAINTS.description.maxLength, `${PRODUCT_TREE_CONSTRAINTS.description.label} must be ${PRODUCT_TREE_CONSTRAINTS.description.maxLength} characters or fewer`),
    brandId: z.string(),
    parentId: z.string(),
});
export function emptyProductTreeEditFormValues(defaults) {
    return { name: '', description: '', brandId: '', parentId: '', ...defaults };
}
//# sourceMappingURL=update-form.js.map